const linkSizeText = {
  small: "button-s",
  medium: "button-m",
  large: "button-xl"
};

export { linkSizeText };
